import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './Checkout.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

function formatPrice(price) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(price);
}

export default function Checkout() {
  const location = useLocation();
  const navigate = useNavigate();
  const items = location.state?.items || [];

  const [form, setForm] = useState({
    guest_name: '', guest_email: '', guest_phone: '', guest_address: '',
    subscribe_newsletter: true, subscribe_wa: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const total = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  if (items.length === 0) {
    return (
      <div className="checkout-page">
        <div className="checkout-empty">
          <p>Keranjang kosong.</p>
          <Link to="/" className="checkout-back">← Kembali ke Beranda</Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const token = localStorage.getItem('saskara_user_token');
      const res = await axios.post(
        `${API_BASE}/orders`,
        {
          items: items.map((i) => ({ product_id: i.product_id, variant_id: i.variant_id, quantity: i.quantity })),
          ...form,
        },
        token ? { headers: { Authorization: `Bearer ${token}` } } : {}
      );
      navigate(`/checkout/success/${res.data.order_id}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal memproses checkout');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="checkout-page">
      <nav className="checkout-nav">
        <Link to="/" className="checkout-back">← Beranda</Link>
      </nav>

      <div className="checkout-layout">
        <div className="checkout-form-section">
          <h1>Checkout</h1>
          {error && <div className="checkout-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Nama Lengkap"
              value={form.guest_name}
              onChange={(e) => setForm({ ...form, guest_name: e.target.value })}
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={form.guest_email}
              onChange={(e) => setForm({ ...form, guest_email: e.target.value })}
              required
            />
            <input
              type="tel"
              placeholder="Nomor HP/WhatsApp"
              value={form.guest_phone}
              onChange={(e) => setForm({ ...form, guest_phone: e.target.value })}
              required
            />
            <textarea
              placeholder="Alamat Pengiriman Lengkap"
              rows={3}
              value={form.guest_address}
              onChange={(e) => setForm({ ...form, guest_address: e.target.value })}
              required
            />

            <label className="checkout-checkbox">
              <input
                type="checkbox"
                checked={form.subscribe_newsletter}
                onChange={(e) => setForm({ ...form, subscribe_newsletter: e.target.checked })}
              />
              Kirimi saya info rilisan terbaru & promo via email
            </label>
            <label className="checkout-checkbox">
              <input
                type="checkbox"
                checked={form.subscribe_wa}
                onChange={(e) => setForm({ ...form, subscribe_wa: e.target.checked })}
              />
              Gabung komunitas WhatsApp Saskara Record
            </label>

            <button type="submit" className="checkout-submit" disabled={loading}>
              {loading ? 'Memproses...' : `Bayar ${formatPrice(total)}`}
            </button>
          </form>
        </div>

        <div className="checkout-summary">
          <h2>Ringkasan Pesanan</h2>
          {items.map((item, i) => (
            <div className="checkout-item" key={i}>
              <div className="checkout-item__photo">
                {item.photo_url && <img src={item.photo_url} alt={item.name} />}
              </div>
              <div className="checkout-item__info">
                <p className="checkout-item__name">{item.name}</p>
                <p className="checkout-item__qty">Qty: {item.quantity}</p>
              </div>
              <p className="checkout-item__price">{formatPrice(item.price * item.quantity)}</p>
            </div>
          ))}
          <div className="checkout-total">
            <span>Total</span>
            <span>{formatPrice(total)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
